import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    Row
} from "reactstrap";
import scanningBarcodeGif from '../../assets/img/logo/conveyor-belt.png';
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import Image from "../Widget/Image";
import {isEmpty} from "../../utils/Utilities";
import WarningLabel from "../Widget/WarningLabel";

// const serialCodeRef = useRef(null)

export default class ConfirmReleaseVerificationFormModal extends BaseComponent{

    constructor(props){
        super(props);
        let releaseVerification = this.props.releaseVerification??{}
        this.state = {
            releaseVerification:releaseVerification,
            releaseVerificationStatus:{}
        }
        this.setState(this.state)
    }


    render(){
        let {releaseVerificationStatus, releaseVerificationStatusWarning} = this.state
        let {releaseVerificationStatusSubmitOptions} = this.props

        return (
            /*xl-lg-sm*/
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="lg"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <CardHeader><h3>{label.ApplyingVerificationResult}</h3></CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <Image style={{width:'400px'}} src={scanningBarcodeGif}/>
                                    <br/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {label.VerificationConfirmDescription}
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col>
                                    <InputGroup
                                        className={"clickable"}
                                        onClick={()=>{
                                            let releaseVerificationStatus = releaseVerificationStatusSubmitOptions[0]
                                            this.setState({
                                                releaseVerificationStatus:releaseVerificationStatus,
                                                releaseVerificationStatusWarning:""
                                            })
                                        }}>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <Input
                                                    id={"passCheckBox"}
                                                    checked={releaseVerificationStatus.id===releaseVerificationStatusSubmitOptions[0].id}
                                                    addon type="checkbox"
                                                    aria-label={releaseVerificationStatusSubmitOptions[0].name}/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            style={{fontSize:'1.5rem', background:'white'}}
                                            disabled
                                            placeholder={label(releaseVerificationStatusSubmitOptions[0].name)} />
                                    </InputGroup>
                                </Col>
                                <Col>
                                    <InputGroup
                                        className={"clickable"}
                                        onClick={()=>{
                                            let releaseVerificationStatus = releaseVerificationStatusSubmitOptions[1]
                                            this.setState({
                                                releaseVerificationStatus:releaseVerificationStatus,
                                                releaseVerificationStatusWarning:""
                                            })
                                        }}>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <Input
                                                    id={"notPassCheckBox"}
                                                    checked={releaseVerificationStatus.id===releaseVerificationStatusSubmitOptions[1].id}
                                                    addon type="checkbox"
                                                    aria-label={releaseVerificationStatusSubmitOptions[1].name}/>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            style={{fontSize:'1.5rem', background:'white'}}
                                            disabled
                                            placeholder={label(releaseVerificationStatusSubmitOptions[1].name)} />
                                    </InputGroup>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col><WarningLabel message={releaseVerificationStatusWarning} show={releaseVerificationStatusWarning}  style={{fontSize:'18px'}}/> </Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        color={"danger"}
                                        onClick={() => this.props.onClickCancel()}>
                                        {label.Close}
                                    </Button>
                                </Col>
                                <Col style={{textAlign:'right'}}>
                                    <Button onClick={() => {
                                        if(isEmpty(releaseVerificationStatus)){
                                            this.setState({
                                                releaseVerificationStatusWarning:label.SelectStatus
                                            })
                                            return
                                        }

                                        this.props.onClickSubmit(releaseVerificationStatus)
                                    }}>{label.Submit}</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

ConfirmReleaseVerificationFormModal.propTypes = {
    show:PropTypes.bool.isRequired,
    releaseVerification:PropTypes.object.isRequired,
    releaseVerificationStatusSubmitOptions:PropTypes.array.isRequired,
    onClickSubmit:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired
}
